import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    textButtonContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      gap: '20px'
    },
    tableResult: {
      margin: '0',
      color: palette.text.white,
      fontWeight: 700,
      display: 'flex',
      gap: '10px'
    },
    title: {
      display: 'flex',
      gap: '10px',
      alignItems: 'flex-start',
      '& h2': {
        fontSize: '1rem',
        fontFamily: 'Montserrat'
      }
    },
    emoji: {
      width: '20px'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
